import { render, staticRenderFns } from "./distribution.vue?vue&type=template&id=1a5a52d0&scoped=true"
import script from "./distribution.vue?vue&type=script&lang=js"
export * from "./distribution.vue?vue&type=script&lang=js"
import style0 from "./distribution.vue?vue&type=style&index=0&id=1a5a52d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.27_cache-loader@4.1.0_webpack@4.47.0__css-load_81040fa6e1252f4179d1cbcf51812dc9/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5a52d0",
  null
  
)

export default component.exports